var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimeFilledWhite = function SvgTimeFilledWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.32 61.6815C60.171 60.9775 60.29 59.7165 59.586 58.8655L50.002 47.2855V27.8425C50.002 26.7375 49.106 25.8425 48.002 25.8425C46.897 25.8425 46.002 26.7375 46.002 27.8425V48.0065C46.002 48.4715 46.164 48.9225 46.461 49.2815L56.504 61.4155C56.899 61.8935 57.47 62.1405 58.046 62.1405C58.495 62.1405 58.947 61.9905 59.32 61.6815ZM48.002 83.4995C28.425 83.4995 12.5 67.5775 12.5 48.0065C12.5 28.4285 28.425 12.5005 48.002 12.5005C67.575 12.5005 83.5 28.4285 83.5 48.0065C83.5 67.5775 67.575 83.4995 48.002 83.4995Z",
    fill: "white"
  })));
};
export default SvgTimeFilledWhite;